export const dataInformes = [
  {
    id: 11,
    url: "https://itetlax.org.mx/assets/img/img_In/documento_11.png",
    alt: "Listado",
    link: "https://itetlax.org.mx/assets/pdf/documento_11.pdf",
  },
  {
    id: 10,
    url: "https://itetlax.org.mx/assets/img/img_In/documento_10.png",
    alt: "Listado",
    link: "https://itetlax.org.mx/assets/pdf/documento_10.pdf",
  },
  {
    id: 9,
    url: "https://itetlax.org.mx/assets/img/img_In/libro_1_1.png",
    alt: "Listado",
    link: "https://itetlax.org.mx/assets/pdf/estudio/1_1.pdf",
  },
  {
    id: 8,
    url: "https://itetlax.org.mx/assets/img/img_In/libro2.png",
    alt: "Listado",
    link: "https://itetlax.org.mx/assets/pdf/informes/libro/2.pdf",
  },
  {
    id: 1,
    url: "https://itetlax.org.mx/assets/img/img_In/libro.png",
    alt: "Listado",
    link: "https://itetlax.org.mx/assets/pdf/informes/libro/1.pdf",
  },
  {
    id: 11,
    url: "https://itetlax.org.mx/assets/img/img_In/libro11.png",
    alt: "Estudio Muestral sobre la participación ciudadana",
    link: "https://itetlax.org.mx/assets/pdf/informes/libro/11.pdf",
  },
  {
    id: 2,
    url: "https://itetlax.org.mx/assets/img/img_In/catalogo1.webp",
    alt: "Listado",
    link: "https://itetlax.org.mx/assets/pdf/informes/QRInformes/1.pdf",
  },
  {
    id: 5,
    url: "https://itetlax.org.mx/assets/img/img_In/catalogo2.webp",
    alt: "Listado",
    link: "https://itetlax.org.mx/assets/pdf/informes/QRInformes/2.pdf",
  },
  
  {
    id: 4,
    url: "https://itetlax.org.mx/assets/img/img_In/2.jpg",
    alt: "Informe de Desempeño de la Operación del Sistema Informático del ITE",
    link: "https://itetlax.org.mx/assets/pdf/informes/2.pdf",
  },
  
  {
    id: 5,
    url: "https://itetlax.org.mx/assets/img/img_In/10.jpg",
    alt: "Memoria del Foro #VotoElectrónico: Posibilidades y desafíos para su instrumentación en México",
    link: "https://bit.ly/3KQdzjo",
  },

  {
    id: 6,
    url: "https://itetlax.org.mx/assets/img/img_In/12.jpg",
    alt: "Reporte Auditoria",
    link: "https://itetlax.org.mx/assets/pdf/auditoria/REPORTE_AUDITORIA_OPL_2024.pdf",
  },

  {
    id: 7,
    url: "https://itetlax.org.mx/assets/img/img_In/Listado.jpg",
    alt: "Listado",
    link: "https://itetlax.org.mx/assets/pdf/carousel/ListadoActualizadoOrganizacion.pdf",
  },

  // {
  //   id: 5,
  //   url: "https://itetlax.org.mx/assets/img/img_In/5.jpeg",
  //   alt: "Catálogo de Presidencias de Comunidad",
  //   link: "https://itetlax.org.mx/assets/pdf/informes/6.pdf",
  // },
];
